export const PredeterminedMySkills = [
  {
    name: 'HTML',
    message: 'I\'ve worked with HTML since junior high school!',
    imageUrl: 'https://storage.googleapis.com/kotakode-prod-public/images/7e4ac728-a66a-44e2-89a6-0db6667a5658-html5.png'
  },
  {
    name: 'CSS',
    message: 'I learn CSS in high school',
    imageUrl: 'https://armyyazilim.com/wp-content/uploads/2019/10/css.png'
  },
  {
    name: 'JS',
    message: 'Being one of my most loved languages, i learn JS a lot and even i had done a JS bootcamp!',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1024px-Unofficial_JavaScript_logo_2.svg.png'
  },
  {
    name: 'Git',
    message: 'After being introduced to Git in my last year of high school, I have used it for all of my projects and work with teams on Git.',
    imageUrl: 'https://i1.wp.com/vatih.com/bisnis/wp-content/uploads/2020/01/1_git.jpg?resize=715%2C359&ssl=1',
  },
  {
    name: 'Python',
    message: 'My most favourite languages and the languages i am the best in.',
    imageUrl: 'https://i.pinimg.com/originals/91/94/c9/9194c978fa63798b2e882e6fda5eb953.png',
  },
  {
    name: 'CP',
    message: 'I do competitive programming since 2019 and i compete a lot in local competitions since i won my country\' national olympiad.',
    imageUrl: 'https://cdn.discordapp.com/attachments/874245493616693269/880265982755635280/unknown.png',
  },
]

export function carouselSlideCardCount(size) {
  switch (true) {
    case size > 1400:
      return 3
    case size > 900:
      return 2
    default:
      return 1
  }

}